import "./HotelRevenueManagement.module.css";
import Header from "@/reusable_sections/Header";
import Faq from "./sections/Faq";
import Testimonials from "./sections/Testimonials";
import RevenueManagementPillars from "./sections/RevenueManagementPillars";
import Hero from "./sections/Hero";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function HotelRevenueManagementPage() {
  return <div>
      <Header />
      <Faq />
      <Testimonials />
      <RevenueManagementPillars />
      <Hero />
      <Consultation />
      <Footer />
    </div>;
}